"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Classe para exibir/esconder os submenus da navegação principal
 */
var TopNavigation =
/*#__PURE__*/
function () {
  function TopNavigation() {
    _classCallCheck(this, TopNavigation);

    // Navegação principal
    this.$navigation = $('#navigation'); // Listas da navegação

    this.$lists = this.$navigation.find('.navigation__list'); // Items de lista

    this.$items = this.$navigation.find('.navigation__list-item'); // Items de lista que possuem sub-navegações

    this.$itemsWithSubmenu = this.$items.has('.sub-navigation'); // Links de navegação

    this.$links = this.$navigation.find('.navigation__list-link'); // Sub-navegações

    this.$subNavigations = this.$navigation.find('.sub-navigation'); // Elemento window do JS

    this.$window = $(window); // Pega os items que possuam sub-navegações e adiciona uma classe nos links

    this.$itemsWithSubmenu.find('> .navigation__list-link').addClass('has-sub');
    this.listeners();
  }

  _createClass(TopNavigation, [{
    key: "listeners",
    value: function listeners() {
      var _this = this;

      this.$linksHasSubmenu.click(function (event) {
        event.preventDefault();
        event.stopPropagation(); // Pega o link que está sendo clicado

        var $this = $(event.currentTarget); // Pega o submenu que deve ser exibido/escondido

        var $submenu = $this.next(_this.$subNavigations); // Retira a classe de todos os links, exceto do link que está sendo clicado

        _this.$links.not($this).removeClass('is-active'); // Esconde todas as sub-navegações, exceto a atual


        _this.$subNavigations.not($submenu).slideUp(200);

        $this.toggleClass('is-active');
        $submenu.slideToggle(200);
      }); // Evento para fechar todos as sub-navegações se for clicado fora

      this.$window.click(function () {
        _this.$links.removeClass('is-active');

        _this.$subNavigations.slideUp(200);
      });
    }
    /**
     * Método para pegar apenas os links que abrem/fecham as sub-navegações
     */

  }, {
    key: "$linksHasSubmenu",
    get: function get() {
      return this.$links.filter('.has-sub');
    }
  }]);

  return TopNavigation;
}();